import Highcharts from 'highcharts';

import {
  DEFAULT_CV,
  DEFAULT_PRICES,
  SIZE_CLASSES,
  expectedRevenueByClassPerGroup,
} from 'views/bluviu-nutrition/features/scenarios-v2/utils/expected-revenue-calculations';
import { ExpectedSalesPriceGraphValue } from 'views/bluviu-nutrition/features/scenarios-v2/types/expected-sales-price-graph.type';

const buildPotentialSalesValueSeries = (graphValues: ExpectedSalesPriceGraphValue[]): Highcharts.SeriesLineOptions[] => {
  const weekMap = new Map<number, number>();

  graphValues.forEach(({ productionWeek: week, guttedWeightEndOfWeek, fishEndWeek }) => {
    const byClass = expectedRevenueByClassPerGroup({ guttedWeightEndOfWeek, fishEndWeek }, DEFAULT_CV, DEFAULT_PRICES);
    const groupTotal = SIZE_CLASSES.reduce((sum, { label }) => sum + (byClass[label] ?? 0), 0);

    weekMap.set(week, (weekMap.get(week) ?? 0) + groupTotal);
  });

  const data = [...weekMap.entries()].sort(([a], [b]) => a - b).map(([week, value]) => [week, value] as [number, number]);

  return [
    {
      type: 'line',
      name: 'Potential Sales Value',
      data,
      marker: { enabled: false, symbol: 'circle' },
    },
  ];
};

export default buildPotentialSalesValueSeries;
